export const amountFields = [
  'penaltyAmount',
  'taxAmt',
  'totalAmount',
  'totalFees',
];

export const TRIAL_BUILD_NOTE = 'Trial: Summary, Collection Summary and TIF Breakdown print manual records as entered. Build Records adds collected taxes to this trial.';

// A trial Build also pulls collected taxes into the trial unless "Manual records only" is ticked,
// so ask first when manual trial rows already exist.
export const shouldConfirmTrialBuild = ({ manualOnly, isTrialSelected, hasManualRows }) => (
  !manualOnly && Boolean(isTrialSelected) && Boolean(hasManualRows)
);

export default {
  amountFields,
  TRIAL_BUILD_NOTE,
  shouldConfirmTrialBuild,
};
